export const DEFAULT_INPUT = {
  investmentAmount: 50000,
  durationYears: 10,
  annualReturn: 12
};

export const INPUT_LIMITS = {
  investmentAmount: {min: 1000, max: 2000000},
  durationYears: {min: 1, max: 50},
  annualReturn: {min: 1, max: 12, step: 0.5}
};

export const investmentSteps = [
  1000, 5000, 10000, 15000, 20000, 25000, 30000, 40000, 50000, 75000,
  100000, 125000, 150000, 175000, 200000, 250000, 300000, 400000, 500000,
  600000, 700000, 800000, 900000, 1000000, 1250000, 1500000, 1750000,
  2000000
];

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

const roundToStep = (value, step) => Math.round(value / step) * step;

const normalizeInput = (input) => ({
  investmentAmount: clamp(
    Math.round(input.investmentAmount),
    INPUT_LIMITS.investmentAmount.min,
    INPUT_LIMITS.investmentAmount.max
  ),
  durationYears: clamp(
    Math.round(input.durationYears),
    INPUT_LIMITS.durationYears.min,
    INPUT_LIMITS.durationYears.max
  ),
  annualReturn: clamp(
    roundToStep(input.annualReturn, INPUT_LIMITS.annualReturn.step),
    INPUT_LIMITS.annualReturn.min,
    INPUT_LIMITS.annualReturn.max
  )
});

export const getMonthlyRate = (annualReturn) =>
  Math.pow(1 + annualReturn / 100, 1 / 12) - 1;

export const calculateLumpsum = (input) => {
  const {investmentAmount, durationYears, annualReturn} = normalizeInput(input);
  const totalMonths = durationYears * 12;
  const monthlyRate = getMonthlyRate(annualReturn);

  let portfolio = investmentAmount;
  const totalInvested = investmentAmount;
  const yearlyData = [];

  for (let month = 1; month <= totalMonths; month += 1) {
    portfolio *= 1 + monthlyRate;

    if (month % 12 === 0) {
      yearlyData.push({
        year: month / 12,
        investedAmount: totalInvested,
        futureValue: portfolio,
        gain: portfolio - totalInvested
      });
    }
  }

  const futureValue = portfolio;
  const gain = futureValue - totalInvested;
  const gainPercent = totalInvested === 0 ? 0 : (gain / totalInvested) * 100;

  return {
    futureValue,
    totalInvested,
    gain,
    gainPercent,
    yearlyData
  };
};

export const formatCurrency = (value) =>
  `₹${Math.round(value).toLocaleString("en-IN")}`;

export const formatGainCurrency = (value) => {
  const amount = Math.round(value);
  const prefix = amount >= 0 ? "+ " : "- ";
  return `${prefix}${formatCurrency(Math.abs(amount))}`;
};

export const formatPercent = (value, fractionDigits = 2) =>
  `${value.toFixed(fractionDigits)}%`;

export const findClosestStepValue = (value) =>
  investmentSteps.reduce((prev, curr) =>
    Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev
  );
